import axios from "axios";

// Environment variables are injected at build time by webpack
// DefinePlugin replaces process.env.ONEHR_API_BASE_URL with the actual string value
const ONEHR_API_BASE_URL = process.env.ONEHR_API_BASE_URL || "http://localhost:4018";

export type Coordinate = { page: number; xPct: number; yPct: number; wPct?: number; hPct?: number };

export type ParticipantField = {
  key: string;
  sort: number;
  label: string;
  type?: "TEXT" | "DATE" | "NUMBER" | "BOOL";
  required?: boolean;
  placeholderCode?: string;
  defaultValue?: string;
  category?: string;
  validation?: any;
};

export type Participant = {
  participantIndex: number;
  type: string;
  Fields?: ParticipantField[]; // Note: Capital F to match backend
  coordinates?: { signature?: Coordinate; stamp?: Coordinate };
  assigneeOrgUnitId?: string;
  assigneeJobDescriptionId?: string;
  assigneeEmployeeId?: string;
};

export type SourceDocumentPlaceholder = {
  id: string;
  sort: number;
  key: string;
  label: string;
  labelMn: string | null;
  labelEn: string | null;
  category: string;
  type: string;
  dataSourceTable: string | null;
  dataSourceField: string | null;
  dataPath: string | null;
  requiresParticipantIndex: boolean;
  applicableToParticipantTypes: string[] | null;
  description: string | null;
  validation: any;
  isSystem: boolean;
  isActive: boolean;
  tags: string[] | null;
};

export type DocumentType = "contract" | "decree" | "job-description";

export async function getTemplate(
  templateIdOrCode: string,
  apiKey?: string,
  documentType: DocumentType = "contract"
) {
  // Get API key from parameter, environment variable, or use default
  const finalApiKey =
    apiKey ||
    process.env.CONTRACT_ADD_IN_X_API_KEY ||
    "784e94dae7b42c27-7bfeaff15ecc1366-9b414877580a4541-bc1654c2f0199bda";

  // Determine the API endpoint based on document type
  const endpoint = `${ONEHR_API_BASE_URL}/api/word-add-in-templates/${documentType}/${templateIdOrCode}`;

  try {
    const { data } = await axios.get(endpoint, {
      headers: {
        "x-api-key": finalApiKey,
        "Content-Type": "application/json",
      },
      timeout: 30000,
    });
    return data;
  } catch (error) {
    throw error;
  }
}
